import { useTranslation } from 'react-i18next';
import { Badge } from '@figma/fpl-components';
import { color } from '@/colors';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';
import { I18N_KEYS } from '@/language/keys';
import { Tag } from './Tag';

interface NewBadgeProps {
  /** The badge hides itself once the current time passes this date, so a stale "New" never lingers. */
  showUntil: Date;
}

/**
 * Temporary "New" badge for flagging a recently-shipped feature in menus. It auto-hides after
 * `showUntil`; once every callsite's date has passed, its usages (and eventually this file) can
 * be removed. Shared by Save, Align, and prompt version history — each passes its own cutoff.
 */
export function NewBadge({ showUntil }: NewBadgeProps) {
  const { t } = useTranslation();
  const isFplMigrationEnabled = useFplMigrationFlag();
  if (new Date() > showUntil) {
    return null;
  }
  const label = t(I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NEW_INDICATOR);

  if (isFplMigrationEnabled) {
    return <Badge variant="defaultFilled">{label}</Badge>;
  }

  return <Tag text={label} textColor={color.White100} bgColor={color.White16_T} sx={{ px: 0.5 }} />;
}
